import { computed } from 'vue'

import { AllowedPages, InternalPages } from '@/enums/allowedPages'
import i18n from '@/libs/i18n'
import { useBulletinStore } from '@/stores/bulletin'
import { useNotificationStore } from '@/stores/notification'
import type { NavLink } from '@/types/Navigation'

export const navItems = computed((): NavLink[] => {
    const t = i18n.global.t

    return [
        { label: t('navigation.quick_overview'), to: 'home', icon: 'i-lucide-layout-dashboard', page: InternalPages.Home },
        {
            label: t('navigation.billing'),
            icon: 'i-lucide-receipt',
            items: [
                { label: t('navigation.regular_billing'), to: 'regular-billing', page: AllowedPages.RegularBilling },
                { label: t('navigation.reserve_fund_billing'), to: 'reserve-fund-billing', page: AllowedPages.ReserveFundBilling }
            ]
        },
        { label: t('navigation.open_items'), to: 'open-items', icon: 'i-lucide-file-text', page: AllowedPages.OpenItems },
        { label: t('navigation.tenants_open_items'), to: 'tenants-open-items', icon: 'i-lucide-users', page: AllowedPages.Tenants },
        { label: t('navigation.card_traffic'), to: 'card-traffic', icon: 'i-lucide-credit-card', page: AllowedPages.CardTraffic },
        { label: t('navigation.readings'), to: 'readings', icon: 'i-lucide-thermometer', page: AllowedPages.Readings },
        {
            label: t('navigation.funds'),
            icon: 'i-lucide-piggy-bank',
            items: [
                { label: t('navigation.reserve_fund'), to: 'reserve-fund', page: AllowedPages.ReserveFund },
                { label: t('navigation.voluntary_fund'), to: 'voluntary-fund', page: AllowedPages.VoluntaryFund },
                { label: t('navigation.reserve_fund_debtors'), to: 'reserve-fund-debtors', page: AllowedPages.ReservedFundDebtors },
                { label: t('navigation.turnover_reserve_fund_books'), to: 'turnover-reserve-fund-books', page: AllowedPages.ReservedFundPostings }
            ]
        },
        {
            label: t('navigation.documents'),
            icon: 'i-lucide-folder-open',
            items: [
                { label: t('navigation.manager_documents'), to: 'manager-documents', page: AllowedPages.ManagerDocuments },
                { label: t('navigation.supplier_documents'), to: 'supplier-documents', page: AllowedPages.SupplierDocuments }
            ]
        },
        { label: t('navigation.notifications'), to: 'notifications', icon: 'i-lucide-bell', number: useNotificationStore().getUnreadNotifications(), page: AllowedPages.Notifications },
        { label: t('navigation.your_units'), to: 'your-units', icon: 'i-lucide-house', page: AllowedPages.YourUnits },
        { label: t('navigation.bulletin_board'), to: 'bulletin-board', icon: 'i-lucide-megaphone', number: useBulletinStore().getUnreadBulletins(), page: AllowedPages.BulletinBoard },
        { label: t('navigation.faq'), to: 'faq', icon: 'i-lucide-circle-help', page: AllowedPages.Faq },
        { label: t('navigation.contractors'), to: 'contractors', icon: 'i-lucide-hard-hat', page: AllowedPages.Contractors },
        { label: t('navigation.cost_specification'), to: 'cost-specification', icon: 'i-lucide-list', page: AllowedPages.CostSpecification },
        { label: t('navigation.registered_people_and_dogs'), to: 'registered-number-of-people-and-dogs', icon: 'i-lucide-dog', page: AllowedPages.RegisteredNumberOfPeopleAndDogs },
        { label: t('navigation.insurance_contracts'), to: 'insurance-contracts', icon: 'i-lucide-shield-check', page: AllowedPages.InsuranceContracts },
        { label: t('navigation.forms'), to: 'forms', icon: 'i-lucide-clipboard-list', page: InternalPages.Forms }
    ]
})
